// BC sends Reason_Code (synced to UserEmployment.reason_code) for every leaver.
// Same four codes the termination-reasons chart counts.
const LEAVER_REASON_LABELS = {
  RESIGN: "Resigned on",
  TERMINATE: "Terminated on",
  ABSCONDING: "Absconded on",
  CONTRACT: "Contract ended on",
};

export const leaverReasonLabel = (reasonCode) =>
  LEAVER_REASON_LABELS[String(reasonCode ?? "").trim().toUpperCase()] ?? "Left on";
